module.exports = __webpack_public_path__ + "static/media/hqt.ea6a7a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hqt.png
// module id = 429
// module chunks = 0 1